module.exports = __webpack_public_path__ + "static/media/curve.d756baa6.svg";